import React from 'react';
import colours from '../../Colours';
import PropTypes from 'prop-types';

// To use this component, simply specify the icon name as the 'name' prop
// E.g. the IcArrowRight icon would be referenced as <Icon name="ArrowRight"/> (without the Ic prefix)
// You can also include the 'size' prop as follows: <Icon name="ArrowRight" size={24}/> (or size="24px")

import {
    IcAddCircle,
    IcArrowDown,
    IcArrowLeft,
    IcArrowRight,
    IcArrowUp,
    IcAttach,
    IcAttentionForm,
    IcContact,
    IcChevronDown,
    IcChevronLeft,
    IcChevronRight,
    IcChevronUp,
    IcClose,
    IcEdit,
    IcEmail,
    IcEmailAlt,
    IcFile,
    IcGlobe,
    IcHide,
    IcInfo,
    IcMinus,
    IcMobile,
    IcNoResults,
    IcPin,
    IcPrize,
    IcPlus,
    IcPrinter,
    IcRefresh,
    IcSChevronLeft,
    IcSChevronRight,
    IcSearch,
    IcShow,
    IcSuccessForm,
    IcTrash,
    IcXCircle,
    Step1,
    Step2,
    Step3
} from './ic';

const components = {
    AddCircle: IcAddCircle,
    ArrowDown: IcArrowDown,
    ArrowLeft: IcArrowLeft,
    ArrowRight: IcArrowRight,
    ArrowUp: IcArrowUp,
    Attach: IcAttach,
    AttentionForm: IcAttentionForm,
    Contact: IcContact,
    ChevronDown: IcChevronDown,
    ChevronLeft: IcChevronLeft,
    ChevronRight: IcChevronRight,
    ChevronUp: IcChevronUp,
    Close: IcClose,
    Edit: IcEdit,
    Email: IcEmail,
    EmailAlt: IcEmailAlt,
    File: IcFile,
    Globe: IcGlobe,
    Hide: IcHide,
    Info: IcInfo,
    Minus: IcMinus,
    Mobile: IcMobile,
    NoResults: IcNoResults,
    Pin: IcPin,
    Prize: IcPrize,
    Plus: IcPlus,
    Printer: IcPrinter,
    Refresh: IcRefresh,
    SChevronLeft: IcSChevronLeft,
    SChevronRight: IcSChevronRight,
    Search: IcSearch,
    Show: IcShow,
    SuccessForm: IcSuccessForm,
    Trash: IcTrash,
    XCircle: IcXCircle,
    Step1: Step1,
    Step2: Step2,
    Step3: Step3
};


const Icon = (props) => {
    let defaultStyle = {fontSize: props.size, justifyContent: 'inherit', display: 'inherit', height: props.size, width: props.size, color: colours.primary.grey01};

    if (Object.keys(components).includes(props.name)) {
        if (props.size) {
            return (
                <span style={props.style ? Object.assign({}, defaultStyle, props.style) : defaultStyle} className={props.className} onClick={props.onClick}>
                    {React.createElement(components[props.name])}
                </span>
            )}
        return React.createElement(components[props.name]);
    } else {
        return null;
    }
}

Icon.defaultProps = {
    size: 24,
    name: 'Hide',
    className: '',
    onCLick: null,
};

Icon.propTypes = {
    size: PropTypes.number,
    name: PropTypes.oneOf(Object.keys(components)),
    className: PropTypes.string,
    onClick: PropTypes.func
}

export default Icon;